import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useRoute } from '../../hooks';
import { NotFound } from '../NotFound';
import { Route } from './Route';
import { useFeatureFlags } from '../../context';
const NotFoundRoute = () => React.createElement(Route, { component: NotFound, path: "", mfe: "core" });
export const DynamicRouter = ({ routes, shouldOverrideRoot }) => {
    const { getFeatureFlag } = useFeatureFlags();
    const isFlagEnabled = getFeatureFlag('tempEnableIaNavigation');
    const { canAccessRoute } = useRoute();
    const { path } = useRouteMatch();
    if (!routes) {
        return null;
    }
    const availableRoutes = isFlagEnabled ? routes : routes.filter((route) => canAccessRoute(route));
    const pathAvailable = availableRoutes.some((route) => route.path === path);
    const addOverride = shouldOverrideRoot && !pathAvailable;
    return (React.createElement(Switch, null,
        addOverride && (React.createElement(Route, { component: availableRoutes[0].component, exact: true, path: path, mfe: "core" })),
        availableRoutes.map((routeConfig) => (React.createElement(Route, { key: routeConfig.path, ...routeConfig }))),
        React.createElement(NotFoundRoute, null)));
};
